import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext, useContextWithValidation } from '@adsk/alloy-react-context';
import { TOOL_IDS } from './consts';
/**
 * Context for current tool ID.
 */
const CurrentToolIdContext = getOrCreateGlobalContext(CONTEXT_NAMES.CurrentToolIdContext);
const useCurrentToolIdContext = () => useContextWithValidation(CurrentToolIdContext, {
  hook: 'useCurrentToolIdContext',
  provider: 'CurrentToolIdProvider'
});
export const useCurrentToolId = () => {
  const currentToolIdContext = useCurrentToolIdContext();
  return currentToolIdContext === null || currentToolIdContext === void 0 ? void 0 : currentToolIdContext.toolId;
};
export const CurrentToolIdProvider = _ref => {
  let {
    children,
    toolId
  } = _ref;
  const value = useMemo(() => {
    return {
      toolId
    };
  }, [toolId]);
  return /*#__PURE__*/React.createElement(CurrentToolIdContext.Provider, {
    value: value
  }, children);
};
CurrentToolIdProvider.displayName = 'CurrentToolIdProvider';
CurrentToolIdProvider.propTypes = {
  /** Nodes with access to context */
  children: PropTypes.node,
  /** The tool ID */
  toolId: PropTypes.oneOf(Object.values(TOOL_IDS))
};
//# sourceMappingURL=CurrentToolIdContext.js.map